import React from "react";
import { Controller } from "react-hook-form";
import { Input, Label } from "reactstrap";

const FormInput = ({ label, name, control, check, required, ...rest }) => {
  if (check) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Label htmlFor={name} check className="pe-4">
            <Input {...field} {...rest} /> {label}
          </Label>
        )}
      />
    );
  }

  return (
    <>
      <Label htmlFor={name}>
        {label}
        {required ? " *" : ""}
      </Label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => <Input {...field} {...rest} />}
      />
    </>
  );
};

export default FormInput;
